module.exports = __webpack_public_path__ + "img/93.c8de80b3.jpg";